// extracted by mini-css-extract-plugin
export var compactFilters = "_gh-4";
export var detailImage = "_gh-1";
export var dropdownContainer = "_gh-2";
export var imageContainer = "_gh-0";
export var selectedCard = "_gh-3";